import { css } from '@emotion/css';
import React, { Suspense } from 'react';
import { connect } from 'react-redux';
import { Action } from 'redux';
import pattern from '../../assets/images/img_passport_bg.svg';
import { actions } from '../../features/passport';
import i18n from '../../i18n';
import { Loading } from '../shared/Loading';
import { LoadingFailed } from '../shared/LoadingFailed';
import { DialogRoute } from '../shared/routes/DialogRoute';
import { TitleHeader } from '../shared/TitleHeader';
import { PassportHintDialog } from './PassportHintDialog';

const PassportContent = React.lazy(() => import('./PassportContent'));

const hintPath = '/players/passport/hint';

class Passport extends React.Component<{ getPassport: () => Action }, { hasError?: boolean }> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }
  public static getDerivedStateFromError(_: any) {
    return { hasError: true };
  }
  componentDidMount() {
    this.props.getPassport();
  }
  public render() {
    return (
      <>
        <main
          className={css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: auto;
            position: relative;
            background-image: url(${pattern});
          `}
        >
          <TitleHeader
            title={i18n.t('passport:top')}
            color="#b4e4b5"
            backLabel={i18n.t('translation:aria_button_back_to_home')}
            hintLabel={i18n.t('passport:aria_help')}
            hintPath={hintPath}
          />
          {this.state.hasError ? (
            <LoadingFailed error="unstable-network" />
          ) : (
            <Suspense fallback={<Loading />}>
              <PassportContent />
            </Suspense>
          )}
        </main>
        <DialogRoute path={hintPath}>
          <PassportHintDialog />
        </DialogRoute>
      </>
    );
  }
}

export default connect(null, dispatch => ({
  getPassport: () => dispatch(actions.getPassport())
}))(Passport);
